<div class="nav-container" data-title="" *ngFor="let child of node?.children">
  <div class="icon-container" (mouseenter)="openNav()" (mouseleave)="closeNav()">
    <span class="glyphicon glyphicon-list-alt nav-icon"></span>
  </div>

  <nav [ngClass]="{ 'hide-nav': !isNavOpen }" class="child-wrap"
    (mouseenter)="openNav()" 
    (mouseleave)="closeNav()">
    <div>
      <a [routerLink]="'/importCsv'" title="Importar archivo CSV">Importar archivo CSV</a>
    </div>
    <div>
      <a [routerLink]="'/quickOrderPage'" title="Carga tu carrito">Carga tu carrito</a>
    </div>
  </nav>
</div>
